<template>
	<section class="d-flex w-100">

		<div class="d-flex flex-column" id="neworders">

			<div class="row header-emotivi mb-3 justify-content-around align-items-end">
				<div class="col">
					<h1>Questionnaires</h1>
				</div>
			</div>

			<div class="flex-grow-1 overflow-hidden d-flex">

				<div class="card card-no-margin">

					<h4>{{ forms_total }} Questionnaires</h4>

					<div class="d-flex justify-content-end align-items-start mb-3" style="margin-top: -60px">
						<m-form-select
							:width="300"
							label="Filtrer par type"
							label-position="top"
							:name="$Utils.randomstring('filterType')"
							v-model="filterType"
							:items="$store.state.items_ed_types"
							@input="loadForms"
						/>
						<m-form-text
							class="ml-3"
							label="Rechercher"
							label-position="top"
							v-model="filterText"
							name="search"
							autocomplete
							@input="loadForms"
						/>
					</div>


					<m-list
						ref="orderslist"
						:dynamic="true"
						:items="orders"
						item-value="or_id"
						:item-height="30"
						:limit="forms_limit"
						:skip="forms_skip"
						:total="forms_total"
						:bgstrip="true"
						@changerange="formsChangeRange"
						@itemclick="editForm"
					>
						<template v-slot:ths="{}">
							<th style="width: 40px">
								#
							</th>
							<th>
								<span class="pointer">Contact</span>
							</th>
							<th>
								<span class="pointer">Bénéficiaire</span>
							</th>
							<th>
								<span class="pointer">Questionnaire</span>
							</th>
							<th>
								<span class="pointer">Mis à jour le</span>
							</th>
						</template>
						<template v-slot:tds="{ item }">
							<td style="width: 40px;'">
								{{ item.no_id }}
							</td>
							<td>
								{{ item.co_id.co_invoice_firstname }} {{ item.co_id.co_invoice_name }}
							</td>
							<td>
								{{ item.en_id ? item.en_id.en_fullname : "---" }}
							</td>
							<td>
								{{ item.ed_label }}
							</td>
							<td >
								{{ $moment(item.updatedAt).format("DD/MM/YYYY HH[H]mm") }}
							</td>
						</template>
					</m-list>		
					<form-win-edit :row_ed_p="itemSelected" v-model="dialog" @reload="loadForms" />
				</div>

			</div>
		</div>
	</section>
</template>

<script>
export default {
  name: "neworders",
  components: { },
  data() {
    return {

      orders: [],
      forms_total: 0,
      forms_limit: 50,
      forms_skip: 0,
      sortOrder: "asc",
      sortFields: [],
      row_en: {},
      filterText: "",
      filterType: "",
      itemSelected: {},
      dialog: false,
    };
  },

  watch: {

  },

  async mounted() {

    let id = parseInt(this.$route.params.no_id);

    if (id) {
      this.itemSelected.no_id = id;
      this.dialog = true;
    }

    this.loadForms();

  },
  computed: {},
  methods: {

    formsChangeRange(skip) {
      this.forms_skip = skip;
      this.loadForms();
    },

    sortItems(fields) {
      if (fields.length && this.sortFields.length && fields[0] == this.sortFields[0]) {
        this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
      }
      this.sortFields = fields;
      this.loadForms();
    },

    async loadForms() {

		let params = {
			skip: this.forms_skip,
			limit: this.forms_limit
		};

		if(this.filterText){
			params.search = this.filterText;
		}

		if(this.filterType){
			params.type = this.filterType;
		}

		this.cancelAxiosLoadForms && this.cancelAxiosLoadForms();

		let response = await this.$axios.get(`${this.$config.server_url}/extranet/2.0/extradata/list`, {
			params,
			cancelToken: new this.$axios.CancelToken(c => {
				this.cancelAxiosLoadForms = c;
			})
		});

		if(!response || !response.data){
			return;
		}

		this.orders = response.data.data;
		this.forms_total = response.data.meta.total;
    },

    editForm(item) {
      this.itemSelected = item;
      this.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/styles.scss";

.label-new {
	position: absolute;
	right: -6px;
	top: 0px;
	width: 6px;
	height: 6px;
	background-color: #f00;
	border-radius: 3px;
}
</style>
